import { Title, TextPartHighlight } from '@components/Sections/Sections.styled';

import { ButtonRectangular } from '@features';

import { MainText } from './MainText';
import { TitlePenOutline, IllustrationPens } from './Pens';
import {
  StyledContainer,
  FirstTitlePart,
  SecondTitlePart,
  TextBlock,
  ReportButtons,
  Quote,
} from './SectionThree.styled';

export const SectionThree: React.FC = () => {
  return (
    <section>
      <StyledContainer>
        <Title>3. To make esports a better place</Title>

        <FirstTitlePart role="presentation" aria-hidden>
          <span>To make</span> <span className="last-word">Esports</span>
        </FirstTitlePart>

        <SecondTitlePart role="presentation" aria-hidden>
          <span>
            a{' '}
            <TextPartHighlight>
              better
              <TitlePenOutline />
            </TextPartHighlight>
          </span>{' '}
          <span className="last-word">place</span>
        </SecondTitlePart>

        <TextBlock
          text={
            <>
              <MainText />
              <ReportButtons>
                <ButtonRectangular
                  isSolid
                  href="https://drive.google.com/file/d/1wEAj6qbjgWs0Maov5-zzi3hwiUTM0xox/view?usp=share_link"
                  text="full-version report"
                  target="_blank"
                  rel="noopener noreferrer"
                />
                <ButtonRectangular
                  href="https://drive.google.com/file/d/1lfgDdvLW0S2kQo3xcNOU4SGHIkZVnIN3/view?usp=share_link"
                  text="short-version report"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </ReportButtons>
            </>
          }
        />

        <Quote
          quote="Getting better at anything takes time and effort. And you need to work hard every day to be better than you were the day before. … And in no case should you give up, because there will be a lot of problems and bad people, and something may not go the way you want. And in your personal life and in the game itself — something may not work out for a very long time. But, most importantly, you need to understand that these are just temporary issues. And if you continue to do something that you do, if you will see your goals clearly before your eyes, then, in the end, all of these will be just little things on the way to success."
          author="Female, professional player"
        />

        <IllustrationPens />
      </StyledContainer>
    </section>
  );
};
